<ng-container [formGroup]="FindingsForm">
    <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
        <!-- cell : Measurements -->

        <div class="w100 summary-anamnesis">
            <section *ngIf="es.ExamType !== 'Holter ECG'" class="m-box">
                <h2>Course of exam</h2>
                <div class="w100 placenta-box placenta-ammiotic">
                    <!-- row (start) -->
                    <div class="l-flex-c l-flex-w l-justify h35 placenta-row">
                    <label class="t-label-top">
                        <span>
                            Duration
                        </span>
                        <span class="t-field t-field--number">
                            <input class="t-field-text" type="number" min="0" [(ngModel)]="DurationMinutes"
                                [ngModelOptions]="{standalone: true}" (input)="updateDuration()"
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57" />
                            <span class="t-field-desc">
                                min
                            </span>
                        </span>
                        <span class="t-field t-field--number">
                            <input class="t-field-text" type="number" min="0" max="59" [(ngModel)]="DurationSeconds"
                                [ngModelOptions]="{standalone: true}" (input)="updateDuration(); limitSeconds()"
                                oninput="this.value = this.value.slice(0,2)" />
                            <span class="t-field-desc">
                                sec
                            </span>
                        </span>
                    </label>

                        <label class="t-label-top">
                            <span>
                                Exam Protocol
                            </span>

                            <select formControlName="Protocol" class="t-select t-field">
                                <option default [ngValue]="null"></option>
                                <option value="Bruce">Bruce</option>
                                <option value="Bruce Modified">Bruce Modified</option>
                                <option value="Bicycle">Bicycle</option>
                                <option value="Accelerated Bruce">Accelerated Bruce</option>
                            </select>

                        </label>

                        <label class="t-label-top">
                            <span>
                                Stage
                            </span>

                            <select formControlName="Stage" class="t-select t-field">
                                <option value="0"></option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>

                            </select>

                        </label>

                        <label class="t-label-top">
                            <span style="width: 100%">
                                Max. {{ FindingsForm.get('Protocol').value == 'Bicycle'? 'WATTs' : 'METs'}}
                            </span>
                            <span class="t-field t-field--number" style="max-width: fit-content">
                                <input class="t-field-text" type="number" min="0" formControlName="METs" />
                            </span>
                        </label>


                    </div>
                    <!-- row (end) -->
                    <!-- row (start) -->
                    <div class="l-flex-c l-flex-w l-justify h35 placenta-row">
                        <label class="t-label-top">
                            <span>
                                Heart Rate at Rest
                            </span>
                            <span class="t-field t-field--number">
                                <input class="t-field-text" type="text" min="0" formControlName="HeartRate" minlength="0" maxlength="3" />
                                <span class="t-field-desc">
                                    bpm
                                </span>
                            </span>
                        </label>

                        <label class="t-label-top">
                            <span>
                                Max Expected HR
                            </span>
                            <span class="t-field t-field--number">
                                <!-- <input class="t-field-text" type="number" min="0"
                                    formControlName="MaxExpectedHeartRate" /> -->
                                    <p class="t-field-text" style="margin: 0;">{{FindingsForm.get('MaxExpectedHeartRate').value | number: '1.0-0'}}</p>
                                <span class="t-field-desc">
                                    bpm
                                </span>
                            </span>
                        </label>
                        <label class="t-label-top">
                            <span>
                                Max HR
                            </span>
                            <span class="t-field t-field--number">
                                <input class="t-field-text" type="number" min="0" formControlName="MaxHeartRate" maxlength="3" />
                                <span class="t-field-desc">
                                    bpm
                                </span>
                            </span>
                        </label>

                        <label class="t-label-top">
                            <span>
                                % of Max Expected
                            </span>
                            <span class="t-field t-field--number">
                                <p class="t-field-text">{{FindingsForm.get('Precentage').value}}</p>
                            </span>
                        </label>
                    </div>
                    <!-- row (end) -->
                    
                    <!-- row (start) -->
                    <div class="l-flex-c l-flex-w l-just-even h35 placenta-row">
                        <label class="t-label-top" *ngIf="es.ExamType == 'Stress-Echo'">
                            <app-geninput [form]="FindingsForm.get('OtherStaff')" fieldnum="2" title="Technologist"></app-geninput>
                        </label>
                        <label class="t-label-top">
                            <span>
                                Blood Pressure at Rest
                            </span>
                            <span class="t-field t-field--number" style="max-width: fit-content">
                                <input class="t-field-text" type="number" maxlength="3"  min="0" formControlName="bpSystolicRest"
                                    style='width: 4em' />/<input class="t-field-text" type="number" maxlength="3"  min="0"
                                    formControlName="bpDiastolicRest" style='width: 4em'>
                                <span class="t-field-desc">
                                    mmHg
                                </span>
                            </span>
                        </label>

                        <label class="t-label-top">
                            <span>
                                Blood Pressure Peak Ex
                            </span>
                            <span class="t-field t-field--number" style="max-width: fit-content">
                                <input class="t-field-text" type="number" maxlength="3"  min="0" formControlName="bpSystolic"
                                    style='width: 4em' />/<input class="t-field-text" type="number" maxlength="3"  min="0"
                                    formControlName="bpDiastolic" style='width: 4em'>
                                <span class="t-field-desc">
                                    mmHg
                                </span>
                            </span>
                        </label>
                    </div>
                    <!-- row (end) -->

                </div>

            </section>

        </div>
        <!-- endcell : Measurements -->
        <div class="w100 summary-anamnesis" *ngIf="es.ExamType == 'Stress-Echo'" style="display: inline-flex;">
            <section class="w100 m-box">
                <h2>Medication</h2>
                <textarea class="scroller" formControlName="Medication"></textarea>
                <!-- /scroller -->

                <button class="t-btn-edit" *ngIf="! es.isClosed"
                    (click)="atS.showAuto(FindingsForm.get('Medication'),'Medication ',500)">Auto
                    Text</button>
            </section>
            <!-- <div class='w50'  *ngIf="es.ExamType == 'Stress-Echo'" >
                <div class="m-box " style="margin-inline-start: 1em;">
                <h2>
                    Resting ECG
                </h2>

                <textarea class="scroller" formControlName="ECG"></textarea>
                <button class="t-btn-edit" *ngIf="! es.isClosed"
                    (click)="atS.showAuto(FindingsForm.get('ECG'),'Resting ECG',46)">Auto Text</button>

                </div>
            </div> -->
        </div>
        <!-- cell : Measurements -->

        <div class="w100 summary-anamnesis" *ngIf="es.ExamType !== 'Holter ECG'">
            <section class="m-box" style="height: auto;">
                <h2>Qualitative Findings</h2>
                <!-- row (start) -->
                <div class="l-flex-c l-flex-w l-justify h50 placenta-row" style="margin: 0 0 1em;">
                    <div class="w49 summary-anamnesis">
                        <section class="m-box">
                            <h2>Clinical Response</h2>
                            <textarea class="scroller" formControlName="Response"></textarea>
                            <!-- /scroller -->

                            <button class="t-btn-edit" *ngIf="! es.isClosed"
                                (click)="atS.showAuto(FindingsForm.get('Response'),'Clinic Response ',506)">Auto
                                Text</button>
                        </section>
                    </div>

                    <div class="w49 summary-anamnesis">
                        <section class="m-box">
                            <h2>Arrhythmia and Conduction</h2>
                            <textarea class="scroller" formControlName="Arythmia"></textarea>
                            <!-- /scroller -->

                            <button class="t-btn-edit" *ngIf="! es.isClosed"
                                (click)="atS.showAuto(FindingsForm.get('Arythmia'),'Arrhythmia and Conduction ',507)">Auto
                                Text</button>
                        </section>
                    </div>
                </div>
                <!-- row (end) -->
                <!-- row (start) -->
                <div class="l-flex-c l-flex-w l-justify h50 placenta-row" style="margin: 1em 0;">
                    <div class="w49 summary-anamnesis">
                        <section class="m-box">
                            <h2>Reason for exam termination</h2>
                            <textarea class="scroller" formControlName="EndReason"></textarea>
                            <!-- /scroller -->

                            <button class="t-btn-edit" *ngIf="! es.isClosed"
                                (click)="atS.showAuto(FindingsForm.get('EndReason'),'Reason for exam termination ',510)">Auto
                                Text</button>
                        </section>
                    </div>

                    <div class="w49 summary-anamnesis">
                        <section class="m-box">
                            <h2>Stress ECG</h2>
                            <textarea class="scroller" formControlName="ST"></textarea>
                            <!-- /scroller -->

                            <button class="t-btn-edit" *ngIf="! es.isClosed"
                                (click)="atS.showAuto(FindingsForm.get('ST'),'ST ',509)">Auto
                                Text</button>
                        </section>
                    </div>
                </div>
                <!-- row (end) -->
                <!-- row (start) -->
                <div class="l-flex-c l-flex-w l-justify h50 placenta-row" style="margin: 1em 0;">
                    <div class="w49 summary-anamnesis">
                        <section class="m-box">
                            <h2>Resting ECG</h2>
                            <textarea class="scroller" formControlName="ECG"></textarea>
                            <!-- /scroller -->

                            <button class="t-btn-edit" *ngIf="! es.isClosed"
                                (click)="atS.showAuto(FindingsForm.get('ECG'),'Resting ECG ',508)">Auto
                                Text</button>
                        </section>
                    </div>

                    <div class="w49 summary-anamnesis">
                        <label class="t-label-top">
                            <span>
                                Pulse Rate 2 min after study end
                            </span>
                            <app-geninput [form]="FindingsForm.get('PulseStatus')" fieldnum="3" title="Pulse"></app-geninput>
                            <span class="t-field t-field--number" *ngIf="FindingsForm.get('PulseStatus').value == 'יש לציין טכיקרדיה במנוחה'">
                                <input class="t-field-text" type="number" min="0" formControlName="PulseRate" />
                                <span class="t-field-desc">
                                    bpm
                                </span>
                            </span>
                        </label>
                    </div>
                </div>
                <!-- row (end) -->
            </section>

        </div>
        <div class="w100 summary-anamnesis" *ngIf="es.ExamType == 'Holter ECG'">
            <section class="m-box" style="height: auto;">
                <h2>Qualitative Findings</h2>
                <!-- row (start) -->
                <div class="l-flex-c l-flex-w l-justify h50 placenta-row" style="margin: 0 0 1em;">
                    <div class="w49 summary-anamnesis">
                        <section class="m-box">
                            <h2>Baseline Heart Rate</h2>
                            <textarea class="scroller" formControlName="baselineHeartrate"></textarea>
                            <!-- /scroller -->

                            <button class="t-btn-edit" *ngIf="!es.isClosed"
                                (click)="atS.showAuto(FindingsForm.get('baselineHeartrate'),'Baseline Heartrate ',369)">Auto
                                Text</button>
                        </section>
                    </div>
                    <div class="w49 summary-anamnesis">
                        <section class="m-box">
                            <h2>Conduction disturbances</h2>
                            <textarea class="scroller" formControlName="Conductiondisturbances"></textarea>
                            <!-- /scroller -->

                            <button class="t-btn-edit" *ngIf="!es.isClosed"
                                (click)="atS.showAuto(FindingsForm.get('Conductiondisturbances'),'Conduction disturbances ',370)">Auto
                                Text</button>
                        </section>
                    </div>
                </div>
                <!-- row (end) -->
                <!-- row (start) -->
                <div class="l-flex-c l-flex-w l-justify h50 placenta-row" style="margin: 1em 0;">
                    <div class="w49 summary-anamnesis">
                        <section class="m-box">
                            <h2>Supra Ventricular Arrhythmia APCS</h2>
                            <textarea class="scroller" formControlName="SupraVentricularArrhythmia"></textarea>
                            <!-- /scroller -->

                            <button class="t-btn-edit" *ngIf="! es.isClosed"
                                (click)="atS.showAuto(FindingsForm.get('SupraVentricularArrhythmia'),'Supra ventricular arrhythmia APCS',372)">Auto
                                Text</button>
                        </section>
                    </div>

                    <div class="w49 summary-anamnesis">
                        <section class="m-box">
                            <h2>ST-T wave Changes</h2>
                            <textarea class="scroller" formControlName="STchanges"></textarea>
                            <!-- /scroller -->

                            <button class="t-btn-edit" *ngIf="! es.isClosed"
                                (click)="atS.showAuto(FindingsForm.get('STchanges'),'ST changes ',371)">Auto
                                Text</button>
                        </section>
                    </div>
                   
                </div>
                <div class="l-flex-c l-flex-w l-justify h50 placenta-row" style="margin: 1em 0; display: flex; justify-content: center;">
                    <div class="w49 summary-anamnesis">
                        <section class="m-box">
                            <h2>Ventricular Arrhythmia PVCS</h2>
                            <textarea class="scroller" formControlName="VentricularArrhythmia"></textarea>
                            <!-- /scroller -->
                
                            <button class="t-btn-edit" *ngIf="! es.isClosed"
                                (click)="atS.showAuto(FindingsForm.get('VentricularArrhythmia'),'Ventricular Arrhythmia PVCS ',373)">Auto
                                Text</button>
                        </section>
                    </div>
                </div>

                <!-- row (end) -->
                <!-- row (start) -->
               
                <!-- row (end) -->
            </section>

        </div>

        <div>
            <section *ngIf="es.ExamType == 'Holter ECG'" class="m-box">
                <h2>Course of Exam</h2>
                <div class="l-flex-c l-flex-w l-justify h35 row" >
                    <!-- row (start) -->
                    
                        <div class="l-flex-c l-flex-w " style="width: 100%; margin: 0.5em; font-size: large;justify-content: space-between;">
                        <label class="t-label-top t-label-top-holter" style="margin-left: 0;">
                            <span style="width: 100%">
                                <strong>Start:   </strong>Date
                            </span>
                            <span class="t-field input-num" style="max-width: fit-content">
                                <input class="t-field-text" type="date" min="0" formControlName="startDateHolter" />
                            </span>
                        </label>
                        <label class="t-label-top t-label-top-holter" style="margin-left: 0;">
                            <span style="width: 100%">
                                Time
                            </span>
                            <span class="t-field input-num" style="max-width: fit-content">
                                <input class="t-field-text" type="time"  formControlName="startTimeHolter" />
                            </span>
                        </label>
                   
                    
                        <label class="t-label-top t-label-top-holter" style="margin-left: 0;">
                            <span style="width: 100%">
                                <strong>End:   </strong>Date
                            </span>
                            <span class="t-field input-num" style="max-width: fit-content">
                                <input class="t-field-text" type="date" min="0" formControlName="endDateHolter" />
                            </span>
                        </label>
                        <label class="t-label-top t-label-top-holter" style="margin-left: 0;">
                            <span style="width: 100%">
                                Time
                            </span>
                            <span class="t-field input-num" style="max-width: fit-content">
                                <input class="t-field-text" type="time"  formControlName="endTimeHolter" />
                            </span>
                        </label>
                   
                        <label class="t-label-top t-label-top-holter" style="margin-left: 0;" >
                            <span >
                                Duration
                            </span>
                                <span class="t-field input-num">
                                    <p class="t-field-text" >{{FindingsForm.get('DurationHours').value}}:{{FindingsForm.get('DurationMin').value}} </p>
                               
                               
                            </span>
                        </label>
                    

                    </div>
                    <!-- row (end) -->
                    <!-- row (start) -->
                    <!-- <div class="l-flex-c l-flex-w " style="width: 100%; margin: 0.5em; font-size: large;"> -->
                        
                        <!-- <label class="t-label-top t-label-top-holter" style="margin-left: 0;">
                            <span>
                                Max Expected HR
                            </span>
                            <span class="t-field input-num">
                                <p class="t-field-text" style="margin: 0;">{{FindingsForm.get('MaxExpectedHeartRate').value | number: '1.0-0'}}</p>
                                <span class="t-field-desc">
                                    bpm
                                </span>
                            </span>
                        </label> -->
                    <!-- </div> -->
                    <div class="l-flex-c l-flex-w " style="width: 100%; margin: 0.5em;" >
                        <label class="t-label-top t-label-top-holter" style="margin-left: 0;">
                            <span style="margin-left: 0.5em;">
                                HR at rest
                            </span>
                            <span class="t-field input-num">
                                <input class="t-field-text" type="text" min="0" formControlName="HeartRate" minlength="0" maxlength="3" />
                                <span class="t-field-desc">
                                    bpm
                                </span>
                            </span>
                        </label>
                        <label class="t-label-top t-label-top-holter" style="margin-left: 0;">
                            <span>
                                Max HR
                            </span>
                            <span class="t-field input-num">
                                <input class="t-field-text" type="number" min="0" formControlName="MaxHeartRate" maxlength="3" />
                                <span class="t-field-desc">
                                    bpm
                                </span>
                            </span>
                        </label>

                        <label class="t-label-top t-label-top-holter" style="margin-left: 0;">
                            <span>
                                Min HR
                            </span>
                            <span class="t-field input-num">
                                <input class="t-field-text" type="number" min="0" formControlName="MinHeartRate" maxlength="3" />
                                <span class="t-field-desc">
                                    bpm
                                </span>
                            </span>
                        </label>
                        <label class="t-label-top t-label-top-holter" style="margin-left: 0;">
                            <span>
                                Average HR total
                            </span>
                            <span class="t-field input-num">
                                <input class="t-field-text" type="number" min="0" formControlName="AverageHRtotal" maxlength="3" />
                                <span class="t-field-desc">
                                    bpm
                                </span>
                            </span>
                        </label>
                    </div>
                    <!-- row start -->
                    <div class="l-flex-c l-flex-w " style="width: 100%; margin: 0.5em; font-size: large;">
                        <label class="t-label-top t-label-top-holter" style="margin-left: 0;">
                            <span>
                                Average HR wake
                            </span>
                            <span class="t-field input-num">
                                <input class="t-field-text" type="number" min="0" formControlName="AverageHRWake" maxlength="3" />
                                <span class="t-field-desc">
                                    bpm
                                </span>
                            </span>
                        </label>
                        <label class="t-label-top t-label-top-holter" style="margin-left: 0;">
                            <span>
                                Average HR at sleep
                            </span>
                            <span class="t-field input-num">
                                <input class="t-field-text" type="number" min="0" formControlName="AverageHRSleep" maxlength="3" />
                                <span class="t-field-desc">
                                    bpm
                                </span>
                            </span>
                        </label>
                    
                    </div>
                    
                    
                 
                    

                </div>

            </section>
            
                <section *ngIf="es.ExamType == 'Holter ECG'" class="m-box" [formGroup]="PatNotesForm">
                    <h2>Patient notes</h2>
                    <div class="l-flex-c l-flex-w l-justify h35 row" *ngIf="!es.isClosed">
                        <label class="t-label-top">
                            <span class="f-label-span">
                               time (hour) 
                            </span>
                            <span class="t-field t-field--number">
                                <input type="text" name="placenta_TEMP_name" class="t-field t-field-text"
                                style="margin-inline-start: 10px;" formControlName="Hour" placeholder="hour">:
                                <input type="text" placeholder="min" name="placenta_TEMP_name" class="t-field t-field-text"
                                style="margin-inline-start: 10px;" formControlName="Min">
                                   
                            </span>
                        </label>
                        <label class="t-label-top">
                          <app-geninput [form]="PatNotesForm.get('patientNote')" fieldnum="4" title="patient notes"></app-geninput>
                        </label>
                        <label class="t-label-top">
                            <app-geninput [form]="PatNotesForm.get('clinicalFindings')" fieldnum="5" title="clinical Findings"></app-geninput>
                        </label>
                        <button class="btnAdd" (click)="savePatNote()">Add</button>

                    </div>
                    <div class="l-flex-c l-flex-w l-justify h35 row" *ngIf="patNotes.length > 0">
                        <table class="table-w">
                            <tr class="l-row"  *ngFor="let patNote of patNotes; let i= index">
                                <td class="l-td center" style="width: auto; white-space: nowrap;">{{i+1 }}</td>
                                 <td class="l-td center" style="width: auto; white-space: nowrap;">{{patNote.TIME }}</td>

                                <td class="l-td center" style="width: 20%;">{{patNote.patientNote}}</td>
                                <td class="l-td center">{{patNote.clinicalFindings}}</td>
                                <td class="l-td-m" *ngIf="!es.isClosed">
                                    <span class="linked-radios-duration">
                                    <img src="../../../assets/icons/del.svg" matTooltip="Delete" matTooltipPosition="right" (click)="deleteNote(patNote.AutoIndex)"></span>
                                </td>
                            </tr>
                        </table>

                    </div>

                </section>
           

            <!-- <div class="w100 summary-anamnesis">
                <section *ngIf="es.ExamType == 'Holter ECG'" class="m-box">
                    <h2>BP measurements</h2>
                    <div class="l-flex-c l-flex-w l-justify h35 row">
                    <div  class="l-flex-c l-flex-w " style="width: 100%; margin: 0.5em; font-size: large;">
                        <label class="t-label-top">
                            <span style="margin-left: 0.5em;">
                                Average Pressure at Rest
                            </span>
                            <span class="t-field t-field--number" style="max-width: fit-content">
                                <input class="t-field-text" type="number" maxlength="3"  min="0" formControlName="bpSystolicRest"
                                    style='width: 4em' />/<input class="t-field-text" type="number" maxlength="3"  min="0"
                                    formControlName="bpDiastolicRest" style='width: 4em'>
                                <span class="t-field-desc">
                                    mmHg
                                </span>
                            </span>
                        </label>

                        <label class="t-label-top">
                            <span>
                                Blood Pressure Peak Ex
                            </span>
                            <span class="t-field t-field--number" style="max-width: fit-content">
                                <input class="t-field-text" type="number" maxlength="3"  min="0" formControlName="bpSystolic"
                                    style='width: 4em' />/<input class="t-field-text" type="number" maxlength="3"  min="0"
                                    formControlName="bpDiastolic" style='width: 4em'>
                                <span class="t-field-desc">
                                    mmHg
                                </span>
                            </span>
                        </label>
                    </div>
                    <div  class="l-flex-c l-flex-w " style="width: 100%; margin: 0.5em; font-size: large;">
                        <label class="t-label-top">
                            <span style="margin-left: 0.5em;">
                               Max BP
                            </span>
                            <span class="t-field t-field--number" style="max-width: fit-content">
                                <input class="t-field-text" type="number" maxlength="3"  min="0" formControlName="maxBPUpper"
                                    style='width: 4em' />/<input class="t-field-text" type="number" maxlength="3"  min="0"
                                    formControlName="maxBPLower" style='width: 4em'>
                                <span class="t-field-desc">
                                    mmHg
                                </span>
                            </span>
                        </label>

                        <label class="t-label-top">
                            <span>
                               Min BP
                            </span>
                            <span class="t-field t-field--number" style="max-width: fit-content">
                                <input class="t-field-text" type="number" maxlength="3"  min="0" formControlName="minBPUpper"
                                    style='width: 4em' />/<input class="t-field-text" type="number" maxlength="3"  min="0"
                                    formControlName="minBPLower" style='width: 4em'>
                                <span class="t-field-desc">
                                    mmHg
                                </span>
                            </span>
                        </label>
                    </div>
                </div>
                </section>
            </div> -->

            <div></div>


        </div>
        <!-- cell : Measurements -->

    </div>
</ng-container>